// extracted by mini-css-extract-plugin
export default {"btn-delete":"btn-delete__lKlmi","icon-wrapper":"icon-wrapper__19San"};